import React from 'react';
import { Box, Card, FormControl, Select, MenuItem, InputAdornment } from '@mui/material';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

export default function LocationSelect({ location, setLocation, locations = [], disabled = false }) {
  return (
    <Card sx={{ width: '100%', p: 0, borderRadius: 1.2, boxShadow: 'none', border: 'none', bgcolor: 'transparent' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FormControl fullWidth sx={{ height: 56 }}>
          <Select
            value={location}
            displayEmpty
            size="small"
            onChange={(e) => setLocation(e.target.value)}
            disabled={disabled}
            sx={{
              height: 56,
              borderRadius: 1.2,
              bgcolor: '#fff',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d4d8dc' },
              '& .MuiSelect-select': {
                height: '56px',
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
                py: 0,
                fontSize: 20,
              },
            }}
            startAdornment={(
              <InputAdornment position="start">
                <StorefrontOutlinedIcon sx={{ color: '#111', fontSize: 22 }} />
              </InputAdornment>
            )}
          >
            <MenuItem value="">-</MenuItem>
            {locations.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </Select>
        </FormControl>
      </Box>
    </Card>
  );
}

